<template>
  <div id="login-container">
    <router-view />
    <div id="logo">
      <router-link to="/index">
        <img src="../../assets/img/logo.png" alt="" />
      </router-link>
    </div>
    <div id="denglu">
      <img src="../../assets/img/chongzmima.png" alt="" />
    </div>
    <div id="login-box">
      <img class="flyicon" src="../../assets/img/flyicon.png" alt="" />
      <div class="chengong">密码重置成功</div>
      <span>下次请使用新密码进行登录</span>
      <el-button type="primary" @click="login()" class="but" label-width="100px"
        >返回登陆</el-button
      >
    </div>
    <div class="return" @click="onReturn()">
      <span>返回登陆</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    // 返回登录事件
    onReturn() {
      this.$router.push("/login");
    },
    login() {
      this.$router.push("/login");
    }
  }
};
</script>

<style lang="less" scoped>
#login-container {
  width: 100%;
  height: 100%;
  min-width: 1000px;
  position: fixed;
  top: 0;
  left: 0;
  background-image: url(../../assets/img/beijing10.png);
  // z-index: -10;
  overflow: auto;
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;

  #logo {
    margin-top: 40px;
    margin-left: 40px;
    margin-bottom: 60px;
    overflow: hidden;
  }

  #denglu {
    width: 235px;
    height: 55px;
    display: block;
    margin: 0 auto;
  }

  #login-box {
    position: absolute;
    width: 520px;
    height: 480px;
    background-color: #fff;
    border-radius: 10px;
    margin: 0 auto;
    margin-top: 50px;
    // margin-left: 700px;
    position: relative;
    .flyicon {
      position: absolute;
      left: 170px;
      top: 60px;
    }
    .chengong {
      width: 180px;
      height: 28px;
      font-size: 30px;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      position: absolute;
      left: 165px;
      top: 270px;
    }
    span {
      color: rgba(169, 172, 187, 1);
      font-size: 13px;
      position: absolute;
      left: 175px;
      top: 320px;
      // margin: 0 auto;
    }
    .but {
      width: 320px;
      height: 50px;
      position: absolute;
      bottom: 0;
      left: 100px;
      margin-bottom: 60px;
      // margin: 0 auto;
    }
  }
}
.return {
  width: 140px;
  height: 50px;
  border: 1px solid rgb(255, 255, 255);
  border-radius: 6px;
  line-height: 50px;
  position: absolute;
  top: 30px;
  right: 35px;
  cursor: pointer;
  span {
    display: block;
    width: 70px;
    margin: 0 auto;
    color: rgba(255, 255, 255, 1);
  }
}
</style>
